export default __webpack_public_path__ + "static/media/a023-startup1-en-short.89e43e32.png";